import { useOrganizationStore } from "../store/useOrganizationStore";
import { useSopStore } from "../store/useSopStore";
import { useSopSelectionStore } from "../store/useSopSelectionStore";
import { useSopEditStore } from "../store/useSopEditStore";
import { useTrackChangesStore } from "../store/useTrackChangesStore";
import { useRegeneratedStepsStore } from "../store/useReviewCommitStore";
import { useDocumentPreviewStore } from "../store/useDocumentPreviewStore";

export function clearSessionOnLogout(): void {
  useOrganizationStore.getState().resetSession();
  useRegeneratedStepsStore.getState().resetAll();
  useDocumentPreviewStore.setState({ bySopId: {} });
  useSopStore.setState({
    sops: [],
    pagination: null,
    versionListsBySopId: {},
    isLoading: false,
    error: null,
  });
  useSopSelectionStore.setState({
    selectedSOP: "",
    selectedVersion: null,
    latestVersion: null,
    baseVersion: null,
    compareVersion: null,
  });
  useSopEditStore.setState({
    isUpdating: false,
    error: null,
  });
  useTrackChangesStore.setState({
    sops: [],
    selectedSOP: "",
    selectedVersion: null,
    latestVersion: null,
    baseVersion: null,
    compareVersion: null,
    isLoading: false,
    isUpdating: false,
    error: null,
    hasUnsavedChanges: false,
  });
}
